// extracted by mini-css-extract-plugin
export default {"prefixedLink":"link_prefixedLink__pdBQT","link":"link_link__364qQ"};